import React from 'react'
// libs
import styled from 'styled-components'
// components
import FormControl from '@mui/material/FormControl'
import { DateTimePicker } from 'components/FormElements'
// views
import ErrorMessage, { ErrorMessageWrapper } from 'components/UI/ErrorMessage'
// types
import { Field } from 'redux-form'
import { WrappedFieldProps } from 'redux-form/lib/Field'
import { CustomDateTimePickerProps } from 'components/FormElements/DateTimePicker'

const ReduxTimePickerWrapper = styled(FormControl)`
  && {
    position: relative;
  }
`

type Props = Omit<CustomDateTimePickerProps, 'onError' | 'onChange'>

const renderComponent = ({
  meta: { touched, error },
  input: { value, onChange },
  ...rest
}: Props & WrappedFieldProps) => {
  return (
    <ReduxTimePickerWrapper margin='none' fullWidth>
      <DateTimePicker {...rest} value={value} onChange={onChange} />
      {touched && error && (
        <ErrorMessageWrapper>
          <ErrorMessage>{error}</ErrorMessage>
        </ErrorMessageWrapper>
      )}
    </ReduxTimePickerWrapper>
  )
}

const ReduxDateTimePicker: React.FC<Props> = (props) => <Field {...props} component={renderComponent} />

export default ReduxDateTimePicker
